import React, { useState, useContext } from 'react'
import AccountDetailsModal from '../../components/admin/AccountDetailsModal'
import AppContext from '../../AppContext'
import { Navigate } from 'react-router-dom'

const UserDetailsView = () => {
  const [redirect, setRedirect] = useState(false)
  const { user } = useContext(AppContext)
  if (redirect) return <Navigate to='/' />
  return (
    <AccountDetailsModal
      initialUser={user}
      showModal
      onCancel={() => setRedirect(true)}
    />
  )
}

export default UserDetailsView
